import Sortable from 'sortablejs';

function initSortable() {
  const listSelector   = '.js-sortable-list';
  const handleSelector = '.js-sortable-handle';
  const sortableItemSelector   = '.js-sortable-item';

  let listElements = document.querySelectorAll(listSelector);

  if (!listElements.length) return;

  listElements.forEach((listElement) => {
    new Sortable(listElement, {
      animation: 150,
      handle: handleSelector,
      onSort: (e) => {
        initSortableUpdateSortField(e.to);
      },
      // Element dragging ended
      onEnd: function (/**Event*/evt) {
        evt.to.querySelectorAll(sortableItemSelector).forEach((item, index) => {
          const rowNumberTag = item.querySelector('.sortable-item-row-number');
          rowNumberTag.innerHTML = index + 1;

          const uuid = item.getAttribute('data-custom_field_uuid');
          const sortInputTag = item.querySelector('input[name="custom_fields_panel[' + uuid + '][sort]');
          if (sortInputTag) {
            sortInputTag.value = index;
          }
        });
      },
    });
  });
}

function initSortableUpdateSortField(parentElement) {
  const sortFieldSelector = '.js-sortable-sort-field';

  if (!parentElement) return;

  parentElement.querySelectorAll(sortFieldSelector).forEach((element, i) => {
    element.value = i;
  });
}

export {initSortable, initSortableUpdateSortField};

